class StickyChecker {
	/**
	 * Setup required properties and init.
	 * @constructor
	 * @returns {void}
	 */
	constructor() {
		this.previousState = false;
		this.currentState = false;
		this.firstLoad = true;

		this.elements = {
			stickyContainers: document.querySelectorAll('.js-sticky-content'),
		}

		if (!this.elements.stickyContainers.length) return;

		this.init();
	}

	/**
	 * Initialise the class by adding watchers.
	 * @returns {void}
	 */
	init() {
		setTimeout(() => {
			this.updateStickies();
		}, 250);

		window.addEventListener('resize', debounce(() => {
			this.updateStickies();
		}, 250));
	}

	/**
	 * Checks heights of sticky elements in containers then updates the classes.
	 * @returns {void}
	 */
	updateStickies() {
		this.checkStickyHeights()
		this.changeStickyBits();
	}

	/**
	 * Checks heights of elements within their container to see if there's room. Sets operations to currentState.
	 * @returns {void}
	 */
	checkStickyHeights() {
		const arrayOfStickyBits = [];
		const windowHeight = window.innerHeight;

		const tableOfContents = document.querySelector('.js-in-page');
		const stickyHeader = document.querySelector('.js-sticky-header');
		const adminBar = document.querySelector('#wpadminbar');

		const tableOfContentsHeight = tableOfContents ? tableOfContents.offsetHeight : 0;
		const stickyHeaderHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
		const adminBarHeight = adminBar ? adminBar.offsetHeight : 0;

		this.elements.stickyContainers.forEach((stickyContainer) => {
			const stickyElement = stickyContainer.querySelector('.js-sticky-element');
			const mq = stickyContainer.dataset.transitionMq;

			let applyClass = false;

			if (mq && window.matchMedia(`(min-width: ${mq})`)) {
				const stickyElementHeight = stickyElement.offsetHeight;

				applyClass = stickyElementHeight + tableOfContentsHeight + stickyHeaderHeight + adminBarHeight + 40 > windowHeight ? true : false;
			}

			arrayOfStickyBits.push({
				el: stickyElement,
				applyClass,
			});
		});

		this.currentState = arrayOfStickyBits;
	}

	/**
	 * Applies classes to elements conditionally.
	 * @param {object} stickyItem An object holding an element and whether to apply the non-stick class.
	 * @returns {void}
	 */
	modifyStickyClasses(stickyItem) {
		const stickyElement = stickyItem.el;
		const applyNonStickClass = stickyItem.applyClass;

		if (applyNonStickClass) {
			stickyElement.classList.add('not-sticky');
		} else {
			stickyElement.classList.remove('not-sticky');
		}
	}

	/**
	 * Check the current state against previous state to see if we need to action changes.
	 * @returns {bool} true or false based on whether the states are the same.
	 */
	checkStates() {
		const stringyPreviousState = JSON.stringify(this.previousState);
		const stringyCurrentState = JSON.stringify(this.currentState);

		if (stringyPreviousState === stringyCurrentState) return true;

		return false;
	}

	/**
	 * If required update the classes and run a view transition if supported. Update previous state.
	 * @returns {void}
	 */
	changeStickyBits() {
		if (this.checkStates()) return;

		if (!document.startViewTransition || this.firstLoad) {
			this.currentState.forEach((stickyObject) => {
				this.modifyStickyClasses(stickyObject);
			});

			this.previousState = this.currentState;

			if (this.firstLoad) this.firstLoad = false;

			return;
		}

		document.startViewTransition(() => {
			this.currentState.forEach((stickyObject) => {
				this.modifyStickyClasses(stickyObject);
			});
		});

		this.previousState = this.currentState;
	}
}

(function ($, document, window) {
	'use strict';

	$(function () {
		new StickyChecker();
	});
})(jQuery, document, window);
